var AdaptiveImage = require( "../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "eacd43bf75b11a52599e848b2b1de7d0.png",
    width: 132,
    height: 148
});